export interface IBuildLimitQueryParams {
  limit?: number;
}

const build = (limit?: number) => {
  if (!limit) return '';
  return `LIMIT ${limit}`;
};

const parse = (query: string): number | undefined => {
  const match = query.match(/\bLIMIT\s+(\d+)/i);
  return match ? parseInt(match[1], 10) : undefined;
};

export { build as buildLimitQuery, parse as parseLimitQuery };
